
export function oddsToStr(odds) {
  const strOdds = `${odds}`;
  const isFraction = /\//.test(strOdds);
  const isDecimal = /\./.test(strOdds);
  return /^\-/.test(strOdds) || isFraction || isDecimal
    ? `${strOdds}`
    : `+${strOdds}`;
}
